import React from 'react';

//import SliderWithLabel from '../../../../../../Shared/React/js/components/sliders/SliderWithLabel';
import type { SearchFilters } from '../../../../../js/@types/SearchFilters';
import SpeedDataSelect from '../../home/SpeedDataSelect';

type SliderProps = SearchFilters['dataSlider'];

interface Props extends SliderProps {
    current: number;
    onChanged: (value: number) => void;
    /** When set (e.g. "100%" on Search page), used as SpeedDataSelect dataWidth. */
    dataWidth?: string;
}

const Data_From = 'From ';
const Data_Format = ' GB';

const DataFilter = (props: Props) => {
    const dataValues = props.values.map((value, index) => {
        const isFirstOrLast = index === 0 || index === props.values.length - 1;
        const label = isFirstOrLast ? value.value : `${Data_From}${value.value}`;
        return {
            key: value.key,
            value: label,
            title: label
        };
    });

    return (
        <>
            <div className="mar-b-4 font-4 c-gray-light line-height-11">{props.dataLabel}</div>
            <div className="selectpicker-wide">
                <SpeedDataSelect
                    primaryFilterAsSpeed={false}
                    dataFormat={Data_Format}
                    dataValues={dataValues}
                    className="dropdown bootstrap-select bs3 show-tick"
                    data={props.current}
                    onDataChange={props.onChanged}
                    dataWidth={props.dataWidth}
                />
            </div>
        </>
    );
};

export default DataFilter;
